module.exports = __webpack_public_path__ + "static/media/r437.b920a505.jpg";